import { logout } from './orval/apiHooks'
import { SESSION_COOKIE_NAME } from '@lib/constants'

export const toLogin = () => {
  window.location.href = '/login'
}

export const clearSessionCookies = async () => {
  if (typeof document === 'undefined') {
    return
  }

  const cookieKey = SESSION_COOKIE_NAME
  document.cookie = `_${cookieKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
  document.cookie = `${cookieKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`

  toLogin()
}

export const clearSessionCookiesRedirect = async () => {
  try {
    await logout()
  } catch (error) {
    console.error('Error during server-side session deletion:', error)
  } finally {
    clearSessionCookies()
  }
}
